import {React} from 'react';
import {TextField} from "@mui/material";
import {istInteger} from '../../lib'

export default function BetragInput(props) {
  const {value,onChange,disabled,size,fullWidth,label,von,bis,variant} = props;

  function Format(newValue,range){
    var tmpvalue=newValue
  
    tmpvalue=tmpvalue.toString().replace(".",":")
    tmpvalue=tmpvalue.replace(/:/g,"")
    tmpvalue=tmpvalue.replace(/^0+/g,"")

    if (istInteger(tmpvalue)===false) {
      return
    }

    if (tmpvalue.length>4){
      return
    }

    if (tmpvalue.length>=2){
      if (Number(tmpvalue.substr(tmpvalue.length-2,2))>59){
        tmpvalue=tmpvalue.substr(0,tmpvalue.length-2)+"59"
      }
    }

    if (tmpvalue.length===0){
      tmpvalue="00.00"
    } else if (tmpvalue.length===1){
      tmpvalue="00.0"+tmpvalue.toString()
    } else if (tmpvalue.length===2){
      tmpvalue="00."+tmpvalue.toString()
    } else if (tmpvalue.length===3){
      tmpvalue="0"+tmpvalue.substr(0,tmpvalue.length-2)+"."+tmpvalue.substr(tmpvalue.length-2,2)
    } else if (tmpvalue.length>3){
      tmpvalue=tmpvalue.substr(0,tmpvalue.length-2)+"."+tmpvalue.substr(tmpvalue.length-2,2)
    }

    if (range){
      if (Number(tmpvalue)<Number(von)){
        Format(von)
        return
      }
      if (Number(tmpvalue)>Number(bis)){
        Format(bis)
        return
      }
    }
    
    onChange(Number(tmpvalue))
  }

  function checkRange(newValue){
    if (Number(von)==NaN||Number(bis)==NaN||(Number(von)==0&&Number(bis)==0)) return
    Format(newValue,true)
  }

  function getValue(){
    var tmpvalue=value
    tmpvalue=tmpvalue.toString().replace(".",":")
    // console.log(tmpvalue) 
    if (Number(tmpvalue)===0){
      return ("00:00")
    } else {  
      
      var pos=tmpvalue.indexOf(":")
      if (pos===-1){
        if (tmpvalue.length===1){
          tmpvalue="0"+tmpvalue+":00"
        } else {
          tmpvalue=tmpvalue+":00"
        }
      } else if (pos===tmpvalue.length-1){
        tmpvalue=tmpvalue+"00"
      } else if (pos===tmpvalue.length-2){
        tmpvalue=tmpvalue+"0"
      } else if (pos<tmpvalue.length-3){
        tmpvalue=tmpvalue.substr(0,pos+3)
      } 

      if (tmpvalue.length>5){
        tmpvalue=tmpvalue.substr(tmpvalue.length-4,4)
      }


      if (tmpvalue.length<5) tmpvalue="0"+tmpvalue

      return (tmpvalue)
    }   
  }

  return (
    <TextField
      label={label}
      disabled={disabled}
      size={size?size:""}
      fullWidth={fullWidth}
      value={getValue()}
      onChange={(e)=>Format(e.target.value)}
      onBlur={(e)=>checkRange(e.target.value)}
      variant={variant?variant:""}
    />
  );
}
